import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    box: {
        padding: "1.25rem",
        borderRadius: "1rem",
        color: tailwindPalette.sky[700],
        background: tailwindPalette.blue[50],
    },
}))

type DeliveryNoteProps = Readonly<{
    text: string
}>

export function DeliveryNote({ text }: DeliveryNoteProps) {
    const { classes } = useStyles()

    if (!text) return null

    return (
        <Typography variant="body1" className={classes.box}>
            {text}
        </Typography>
    )
}
